import { DimensionContext } from "@src/DimensionProvider";
import React from "react";
import { Text, View } from "react-native";
import useStyles from "./styles.css";

export default function Table() {
  const styles = useStyles();
  const { baseWidth } = React.useContext(DimensionContext);

  const leftText = `
Цел\n
Създайте и управлявайте своя акаунт; предоставяне на платформата и основните функции\n
Провеждане на програмата за награди Palms Fun; проследяване на монети без парични средства; Управление на откупувания\n
Проверете допустимостта/възрастта; предотвратяване на злоупотреби/измами; Осигуряване на справедливо използване и сигурност\n
Обслужване на клиенти и комуникации с обслужване\n
Подобрение на услуги, анализ и отстраняване на грешки\n


Маркетингови имейли/бюлетини (където е приложимо)\n
Правни и съответствия (отговаряне на законни искания, счетоводство)
`;

  const rightText = `
Законна основа\n
Договор (чл. 6(1)(б))\n


Договор; Легитимни интереси (почтеност на службата)\n

Законни интереси (измама/сигурност); Правно задължение , ако е приложимо\n
Договор; Легитимни интереси\n

Легитимни интереси (подобряване на потребителското изживяване и стабилност)\n
Съгласие (opt-in) – оттегляне по всяко време\n
Правно задължение; Легитимни интереси
`;

  return (
    <View style={{flexDirection: "row", justifyContent: "flex-start", gap: 50}}>
      <Text
        style={[styles.t_regular,{
          fontSize: baseWidth * 0.012
        }]}
      >
        {leftText}
      </Text>
      <Text
        style={[styles.t_regular,{
          fontSize: baseWidth * 0.012
        }]}
      >
        {rightText}{"\n"}
      </Text>
    </View>
  );
}
